import request from '@/utils/request'

let Vehicle_classificationApi = {

  /*车辆分类列表*/
  list(data) {
    return request._post('/shop/plus.vehicle_classification.Index/index', data);
},
/*添加车辆分类*/
add(data) {
    return request._post('/shop/plus.vehicle_classification.Index/add', data);
},
/*修改车辆分类*/
edit(data) {
    return request._post('/shop/plus.vehicle_classification.Index/edit', data);
},
/*删除车辆分类*/
del(data) {
    return request._post('/shop/plus.vehicle_classification.Index/del', data);
},
/*车辆分类详情*/
detail(data) {
  return request._post('/shop/plus.vehicle_classification.Index/detail', data);
},
    saveSetting(data, errorback) {
        return request._post('/shop/plus.vehicle_classification.Setting/getSetting', data, errorback);
    },
    getSetting(data, errorback) {
        return request._get('/shop/plus.vehicle_classification.Setting/getSetting', data, errorback);
    },
}
export default Vehicle_classificationApi;



// WEBPACK FOOTER //
// ./src/api/vehicle_classification.js